/**
 * Провайдер ЭДО: строковые значения совпадают с JSON API бэка
 * (`JsonStringEnumConverter`, см. `Telemedicine.Domain.Enums.EdoCompany`).
 */
export enum EdoCompany {
    Undefined = "Undefined",
    Kontur = "Kontur",
    Astral = "Astral",
    Sbis = "Sbis",
}
